import { render } from "./ExtranetLayout.vue?vue&type=template&id=1b31cba8&scoped=true"
import script from "./ExtranetLayout.vue?vue&type=script&lang=js"
export * from "./ExtranetLayout.vue?vue&type=script&lang=js"

import "./ExtranetLayout.vue?vue&type=style&index=0&id=1b31cba8&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b31cba8"]])

export default __exports__